<template>
  <div class="aboutNavigation">
    <div class="titleBox d-block d-lg-none">
      <h2>
        关于我们
        <button @click='toBack' class="btn btn-primary btn-lg btn-round d-block d-lg-none">商城 <i class="iconfont icon-more1"></i></button>
      </h2>
      <hr>
      <p class="content">欢迎联系们！</p>
    </div>
    <ul class="clearfix">
      <li class="title">关于我们</li>
      <router-link active-class='active' exact tag='li' to="/about">
        雪帝简介
      </router-link>
      <router-link active-class='active' exact tag='li' to="/about/lianxi">
        联系我们
      </router-link>
    </ul>
    <ul class="clearfix">
      <li class="title">购物指南</li>
      <router-link active-class='active' exact tag='li' to="/about/tiaokuan">
        交易条款
      </router-link>
      <router-link active-class='active' exact tag='li' to="/about/shouhou">
        售后服务
      </router-link>
    </ul>
    <ul class="clearfix">
      <li class="title">服务中心</li>
      <router-link active-class='active' exact tag='li' to="/about/yinsi">
        隐私声明
      </router-link>
      <router-link active-class='active' exact tag='li' to="/about/xieyi">
        注册协议
      </router-link>
<!--      <router-link active-class='active' exact tag='li' to="/about/kefu">-->
<!--        联系客服-->
<!--      </router-link>-->
    </ul>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  components:{
  }
}
</script>

<style scoped lang='less'>
.aboutNavigation{
  margin: 0;
  .titleBox {
    margin-top: 30px;
    margin-bottom: 30px;
    p {
      margin: 0;
    }
  }
  ul{
    margin-bottom: 10px;
    li{
      line-height: 2.8em;
      margin-bottom: 5px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
      color: rgba(0,0,0,0.6);
      &.title{
        font-size: 1.2em;
        border-radius: 0;
        cursor: default;
        color: #000000;
        font-weight: bold;
        margin: 0;
        &:hover{
          background: none;
        }
      }
      &.active{
        background-color:rgba(0,0,0,0.1);
        background: #FFFFFF;
        color: #000000;
      }
      &:hover{
        background-color: #FFFFFF;
        color: #000000;
      }
      &:last-child{
        margin: 0;
      }
    }
  }
}
@media (max-width: 1200px) {
  .aboutNavigation{
  }
}
@media (max-width: 992px) {
  .aboutNavigation{
    margin-bottom: 10px;
    .titleBox {
      margin-top: 0;
      h2{
        display: flex;
        justify-content: space-between;
      }
      p {
        margin: 0;
        color: #9B9B9B;
      }
    }
    ul {
      margin-bottom: 0;
      li{
        margin: 0;
        float: left;
        margin-right: 5px;
        line-height: 2.5em;
        padding: 0 10px;
        &:first-child{
          padding-left: 0;
        }
        &.title{
          font-size: 1em;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .homeCenter{
    .titleBox {
      p{
        padding: 0 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/Navigation.vue